DigiTickets.MembershipDobRequirement = Object.freeze({
    /**
     * Values for "is capturing a data of birth mandatory for a membership plan?"
     */
    NO: 0,
    MANDATORY: 1,
    CHILDREN_ONLY: 2
});
